module.exports = __webpack_public_path__ + "img/faming14.7cf3c002.png";